export enum AccountType {
  Trainer, Brand, Admin, Company,
}
